
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","width":"12","height":"12"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.325 1.417h3.35a.2.2 0 00.2-.2v-.35a.2.2 0 00-.2-.2h-3.35a.2.2 0 00-.2.2v.35c0 .11.09.2.2.2zm6.027 1.3h.698a.2.2 0 00.2-.2v-.425a.2.2 0 00-.2-.2H.95a.2.2 0 00-.2.2v.425c0 .11.09.2.2.2h.699v8.128q0 .202.142.344.143.143.345.143h7.728q.202 0 .345-.143.143-.142.143-.344V2.717zm-.825 0H2.474v7.79h7.053v-7.79zM4.221 4.395v4.1c0 .11.09.2.2.2h.425a.2.2 0 00.2-.2v-4.1a.2.2 0 00-.2-.2h-.425a.2.2 0 00-.2.2zm2.733 0v4.1c0 .11.09.2.2.2h.425a.2.2 0 00.2-.2v-4.1a.2.2 0 00-.2-.2h-.425a.2.2 0 00-.2.2z","fill-rule":"evenodd","fill":"currentColor"}})])
          )
        }
      }
    